import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ApiError } from '../../../core/auth/auth.models';
import { AuthService } from '../../../core/auth/auth.service';

@Component({
  selector: 'app-accept-invite',
  imports: [ReactiveFormsModule, RouterLink],
  templateUrl: './accept-invite.html',
})
export class AcceptInvite {
  private readonly fb = inject(FormBuilder);
  private readonly auth = inject(AuthService);
  private readonly route = inject(ActivatedRoute);

  protected readonly tenant = this.route.snapshot.paramMap.get('tenant') ?? '';
  protected readonly token = this.route.snapshot.queryParamMap.get('token') ?? '';

  /**
   * Nome legível da empresa a partir do slug do link ("padaria-central-lda" → "Padaria Central
   * Lda"). Mostrar o slug técnico a quem está a ativar o acesso não diz nada.
   */
  protected readonly companyName = this.tenant
    .split('-')
    .filter(Boolean)
    .map((part) => (part.length <= 3 ? part.toUpperCase() : part.charAt(0).toUpperCase() + part.slice(1)))
    .join(' ');
  protected readonly form = this.fb.nonNullable.group({
    password: ['', [Validators.required, Validators.minLength(8)]],
    confirm: ['', Validators.required],
  });
  protected readonly loading = signal(false);
  protected readonly serverError = signal<string | null>(null);
  protected readonly done = signal(false);

  protected submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const { password, confirm } = this.form.getRawValue();
    if (password !== confirm) {
      this.serverError.set('As palavras-passe não coincidem.');
      return;
    }
    this.loading.set(true);
    this.serverError.set(null);
    this.auth.acceptInvite(this.tenant, this.token, password).subscribe({
      next: () => {
        this.loading.set(false);
        this.done.set(true);
      },
      error: (error: HttpErrorResponse) => {
        this.loading.set(false);
        this.serverError.set((error.error as ApiError)?.message ?? 'Não foi possível ativar o convite.');
      },
    });
  }
}
